import { css, useTheme } from '@emotion/react';

const useStyle = () => {
  const theme = useTheme();

  const { primary, background, secondary } = theme.palette;
  const { lg, md, sm } = theme.breakpoints.values;
  const { spacing } = theme;

  const componentWrapper = css`
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    padding: 100px 137px;
    background: ${background.gray3};
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (max-width: ${`${lg}px`}) {
      padding: 100px 35px;
    }

    @media (max-width: ${`${md}px`}) {
      padding: 50px 25px;
    }

    & > p {
      text-align: center;

      @media (max-width: ${`${sm}px`}) {
        width: 100%;
        text-align: left;
      }
    }
  `;

  const componentHeader = css`
    margin-bottom: ${spacing(1)};
  `;

  const buttonsWrapper = css`
    width: 100%;
    display: flex;
    gap: ${spacing(1)};
    margin: ${spacing(4, 'auto', 1)};

    @media (max-width: ${`${md}px`}) {
      flex-wrap: wrap;
      justify-content: center;
    }
  `;

  const componentButton = css`
    text-transform: capitalize;
    width: 100%;

    @media (max-width: ${`${lg}px`}) {
      min-width: 192px;
    }

    &:not([disabled]):hover {
      @media (max-width: ${`${lg}px`}) {
        background: ${primary.main};
        border-color: ${primary.main};
      }
    }
  `;

  const reviewsContainer = css`
    width: 100%;
    border: 2px solid white;
    overflow: hidden;

    @media (max-width: ${`${lg}px`}) {
      border: none;
    }
  `;

  const reviewsContainerChildren = css`
    width: 100%;
    padding: 50px 75px;
    display: flex;
    gap: ${spacing(1)};

    @media (max-width: ${`${lg}px`}) {
      padding: 10px 0 0;
      gap: 10px;
    }

    @media (max-width: ${`${md}px`}) {
      display: none;
    }
  `;

  const reviewCard = css`
    width: 100%;
    height: 100%;
    background: white;
    border-radius: 15px;
    padding: ${spacing(3)};

    @media (max-width: ${`${md}px`}) {
      width: calc(100% - 50px);
      margin: 0 auto;
    }
  `;

  const reviewCardPerson = css`
    display: flex;
    gap: ${spacing(1)};
    align-items: center;

    & b {
      display: block;
      font-size: 16px;
      line-height: 18px;
    }

    & i {
      display: flex;
      align-items: center;
      font-size: 14px;
      line-height: 18px;
    }
  `;

  const starsWrapper = css`
    display: flex;
    margin: ${spacing(1, '0')};
    color: ${secondary.dark};
  `;

  const mobileSlideShowWrapper = css`
    display: none;

    @media (max-width: ${`${md}px`}) {
      display: block;
      width: 100%;
    }
  `;

  const mobileSlideShowStyle = css`
    display: none;

    @media (max-width: ${`${md}px`}) {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: ${spacing(2)};
    }
  `;

  const slideShowWrapper = css`
    width: 100%;

    @media (max-width: ${`${md}px`}) {
      width: calc(100% + 50px);
    }
  `;

  const ctaWrapper = css`
    width: 100%;
    max-width: 290px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: ${spacing(1)};
    margin-top: ${spacing(3)};
    align-items: center;

    & > p {
      font-size: 14px;
      line-height: 14px;
    }

    @media (max-width: ${`${md}px`}) {
      margin-top: ${spacing(2)};
    }
  `;

  const seeMoreReviewsStyle = css`
    margin-top: ${spacing(2)};
  `;

  return {
    componentWrapper,
    componentHeader,
    buttonsWrapper,
    componentButton,
    reviewsContainer,
    reviewsContainerChildren,
    reviewCard,
    reviewCardPerson,
    starsWrapper,
    mobileSlideShowWrapper,
    mobileSlideShowStyle,
    slideShowWrapper,
    ctaWrapper,
    seeMoreReviewsStyle,
  };
};

export default useStyle;
